import { StrategyLabels } from './config/attribute-labels'
import { FactorLabels } from './config/attribute-labels'

function labelFor(key, labels) {
  const label = labels[key]

  if (!label && process.env.NODE_ENV !== 'production') {
    if (typeof console !== typeof undefined) {
      console.warn(`Failed to find an attribute label for key "${key}".`)
    }

    return key
  }

  return label
}

export function labelForStrategy(key) {
  return labelFor(key, StrategyLabels)
}

export function labelForFactor(key) {
  return labelFor(key, FactorLabels)
}



// WEBPACK FOOTER //
// ./src/attributes.js